
import React, { useEffect, useRef } from 'react';
import { Button, View } from '../Components/Themed';
import { useNotifications } from './useNotifications';
import type { EventSubscription } from 'expo-notifications';
import * as Notifications from 'expo-notifications';

Notifications.setNotificationHandler({
    handleNotification: async () => ({
      shouldShowAlert: true,
      shouldPlaySound: false,
      shouldSetBadge: false,
      shouldShowBanner: true,
      shouldShowList: true
    }),
  });

const NotificationModule = ({}) => {
    const Notification = useNotifications();
    const notificationListener = useRef<EventSubscription>();
    const responseListener = useRef<EventSubscription>();

    useEffect(() => {
        notificationListener.current = Notifications.addNotificationReceivedListener(notification => {
            console.log('Got a notification!!!!!');
            console.log(notification)
          });
          responseListener.current = Notifications.addNotificationResponseReceivedListener(response => {
            console.log(response);
          });
    },[]);

    return (
        <View>
            <Button
                style={{ margin:5 }}
                type='info'
                title='Get Permission'
                onPress={() => Notification.getPermission()}
            />
            <Button
                style={{ margin:5 }}
                type='info'
                title='Request Permission'
                onPress={() => Notification.requestPermission()}
            />
            <Button
                style={{ margin:5 }}
                type='info'
                title='Get My Token'
                onPress={() => Notification.getMyToken()}
            />
            <Button
                style={{ margin:5 }}
                type='info'
                title='Get My Expo Token'
                onPress={() => Notification.getMyExpoToken()}
            />
            <Button
                style={{ margin:5 }}
                type='info'
                title='Send Notification'
                onPress={() => {
                    Notifications.scheduleNotificationAsync({
                        content: {
                        title: 'Look at that notification',
                        body: "I'm so proud of myself!",
                        },
                        trigger: null,
                    });
                }}
            />

        </View>
    )

}

export default NotificationModule